export enum UserDataCustomType {
  SubtitleFull = "SubtitleFull",
  SubtitlePartial = "SubtitlePartial",
  SubtitleFullWithoutPartial = "SubtitleFullWithoutPartial",
}
